//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      code: this.$route.query.code || '',
      nickname: '成员',
      info: {}
    }
  },
  created () { if (this.code) this.preview() },
  methods: {
    preview () {
      this.$ajax.get(this.$api.etJoinInfo + '?code=' + encodeURIComponent(this.code)).then(r => { this.info = r || {} })
    },
    join () {
      this.$ajax.post(this.$api.etTreeJoin, { code: this.code, nickname: this.nickname }).then(r => {
        this.$router.replace({ path: '/etDetail_display', query: { id: r.tree_id } })
      }).catch(e => { this.$toast && this.$toast(e.message || '失败') })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/etymology-tree/join.vue